import React from 'react';

import usePharmacyList from '../../../hooks/Admin/PharmacyList/usePharmacyList';
import useUserNotFound from '../../../hooks/useUserNotFound';

import DynamicTable from '../../DynamicTable';
import PharmacyListHeader from './PharmacyListHeader';

const PharmacyList = () => {
  const {
    table,
    page,
    handlePagination,
    selectedTab,
    setSelectedTab,
    handleReset,
    formik,
    loadSuccess,
    rowData,
    totalCount,
    order,
    orderBy,
    handleSorting,
    canBulkAssign,
    selectAll,
    handleSelectAll,
    bulkAssignOwner,
    hasSelection,
    isMyAccounts,
  } = usePharmacyList();

  const { length } = rowData;
  const { showUserNotFound } = useUserNotFound(loadSuccess, !!length);

  return (
    <DynamicTable
      table={table}
      loadSuccess={loadSuccess}
      totalCount={totalCount}
      page={page}
      order={order}
      orderBy={orderBy}
      handleSort={handleSorting}
      handlePagination={handlePagination}
      emptyContainerComponent={showUserNotFound()}
      customHeader={(
        <PharmacyListHeader
          selectedTab={selectedTab}
          setSelected={setSelectedTab}
          formik={formik}
          handleReset={handleReset}
          canBulkAssign={canBulkAssign}
          selectAll={selectAll}
          handleSelectAll={handleSelectAll}
          bulkAssignOwner={bulkAssignOwner}
          hasSelection={hasSelection}
          isMyAccounts={isMyAccounts}
        />
      )}
      showHeader={false}
    />
  );
};

export default PharmacyList;
